module.exports = __webpack_public_path__ + "img/ba-bot-row@2x.031a05d6.png";